module.exports = __webpack_public_path__ + "media/ms-number.70ebd5ba.mp3";